import React from 'react'
import { TasksDueDataTable } from './TasksDue/TasksDueDataTable'

const TasksDue = () => {
  return (
    <div className="space-y-4">
      <TasksDueDataTable />
    </div>
  )
}
export default TasksDue
